import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  gap: ${Variables.space75};
  padding: ${Variables.space75} ${Variables.space100};
  background-color: ${Variables.colourNeutral2};
  border-radius: ${Variables.radiusS};
  margin-bottom: ${Variables.space50};
`;

export const SecondRow = styled.div`
  color: ${Variables.colourTextAndIcon2};
`;

export const HideOnMobile = styled.td`
  @media (max-width: ${Variables.breakpointM}) {
    display: none;
  }
`;

export const HideOnMobileHeader = styled.th`
  font-size: ${Variables.fontSize100};
  @media (max-width: ${Variables.breakpointM}) {
    display: none;
  }
`;

export const CheckboxHeader = styled.th`
  box-sizing: content-box;
  width: ${Variables.space150};
  white-space: nowrap;
`;

export const CheckboxCell = styled.td`
  vertical-align: middle;
  text-align: center;
  white-space: nowrap;
`;

export const ClickableRow = styled.tr`
  cursor: pointer;
`;

export const ActionCell = styled.td`
  vertical-align: middle;
  text-align: center;
`;

export const SortableHeader = styled.th<{ active?: boolean }>`
  cursor: pointer;
  font-weight: ${({ active }) =>
    active ? Variables.fontWeightBold : "inherit"};
  white-space: nowrap;
  font-size: ${Variables.fontSize100};
`;

export const HideOnMobileSortableHeader = styled(SortableHeader)`
  @media (max-width: ${Variables.breakpointM}) {
    display: none;
  }
`;
